<template>
  <div class="page">
    <div class="container">
      <div class="page__wrapper">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.page {
  background-image: url(@images/bg/mainBg.png);
  background-size: 100%;
  background-repeat: repeat;

  &__wrapper {
    padding: 70px 85px 100px 85px;
    background-color: $white;
  }
}

@media (max-width: 750px) {
  .page {
    &__wrapper {
      padding: 50px 60px 75px 60px;
    }
  }

  :deep(.docs__block-title) {
    font-size: 24px !important;
    line-height: 28px;
  }
  :deep(.docs__block-text) {
    font-size: 14px !important;
    line-height: 18px;
  }
}

@media (max-width: 450px) {
  .page {
    &__wrapper {
      padding: 50px 40px 75px 40px;
    }
  }

  :deep(.docs__back-text) {
    font-size: 24px !important;
  }
}
</style>